function initMessageLabelsTypeahead(target, labels) {
    // https://twitter.github.io/typeahead.js/examples/
    const {messageId, mpAppEntityUUID} = target
    const elem = $("#messageLabelsInput-" + (messageId || mpAppEntityUUID));
    elem.typeahead({minLength: 0, hint: false, highlight: true},
        {
            name: "messageLabels",
            displayKey: 'text',
            source: function (query, callback) {
                const matches = []
                $.each(labels, function (i, label) {
                    if (matches.length > 10) return;
                    if (query === '' || label.text.indexOf(query) > -1) {
                        matches.push(label);
                    }
                });

                callback(matches);
            },
            templates: {
                suggestion: function ({background, foreground, text}) {
                    return '<div class="col-sm-offset-1">' +
                        `<span class="badge" style="background: ${background}; color: ${foreground}">${text}</span>` +
                        '</div>';
                }
            }
        }
    ).on("typeahead:selected", function (evt, item) {
        messageLabelsAction({action: 'add', labelId: item.id, ...target});
        elem.typeahead("val", "").trigger("keyup");
    });

    // Manuell die Vorschläge anzeigen, wenn das Feld fokussiert wird
    elem.focus(function () {
        elem.typeahead('val', 'a').trigger("keyup"); // Temporär ein a hinzufügen (Leerzeichen funktioniert nicht)
        elem.typeahead('val', '').trigger("keyup");  // Leerzeichen wieder entfernen, um Source-Callback zu triggern
    });
}

function manageMessageLabels(target) {
    const {messageId, mpAppEntityUUID} = target
    const input = $('#messageLabelsInput-' + (messageId || mpAppEntityUUID));
    if (input.attr("data-new") !== "true") return;
    input.parent().on('shown.bs.collapse', function () {
        messageLabelsAction({action: "fetch", labelId: -1, ...target});
        input.focus();
    });
    input.parent().on('hidden.bs.collapse', function () {
        messageLabelsAction({action: "fetch", labelId: -1, edit: false, ...target});
    });
    $.ajax({
        url: '/' + appLocation + `listMessageLabels`,
        context: document.body,
        type: 'post'
    }).done(function (response) {
        initMessageLabelsTypeahead(target, JSON.parse(response));
        input.attr("data-new", "false");
    });

}

function messageLabelsAction({action, messageId, mpAppEntityUUID, labelId, edit = true}) {

    if (messageId) {
        $.ajax({
            url: '/' + appLocation + 'messageLabelsAction',
            context: document.body,
            type: 'post',
            data: {action, messageId, labelId, edit}
        }).done(function (fragment) {
            $(".messageLabels-" + messageId).replaceWith(fragment)
        }).fail(function (e) {
            actionFail()
        })
    } else if (mpAppEntityUUID) {
        $.ajax({
            url: '/' + appLocation + 'mediprimeApp/labelsAction',
            context: document.body,
            type: 'post',
            data: {action, mpAppEntityUUID, labelId, edit}
        }).done(function (fragment) {
            $(".messageLabels-" + mpAppEntityUUID).replaceWith(fragment)
        }).fail(function (e) {
            actionFail()
        })
    }

}

function createMessageLabel() {
    $.ajax({
        url: `/${appLocation}labels/new`,
        context: document.body, type: 'get'
    }).done(function (response) {
        actionSuccess();
        document.getElementById('messageLabelSettings').innerHTML = response;
        initMessageLabelColorPicker();
    }).fail(function (e) {
        actionFail()
    });
}

function deleteMessageLabel(labelId) {
    $.ajax({
        url: `/${appLocation}labels/${labelId}/delete`,
        context: document.body, type: 'get'
    }).done(function (response) {
        actionSuccess();
        document.getElementById('messageLabelSettings').innerHTML = response;
        initMessageLabelColorPicker();
    }).fail(function (e) {
        actionFail()
    });
}

function setMessageLabelSetting(labelId, setting, value) {
    $.ajax({
        url: `/${appLocation}labels/${labelId}/setting`,
        context: document.body, type: 'post', data: {setting, value}
    }).done(function () {
        if (setting === "background") {
            const bg = window.getComputedStyle(document.getElementById('labelBackgroundPreview-' + labelId)).backgroundColor
            const fg = $('#labelForegroundInput-' + labelId)
            fg.val(determineTextColor(bg))
            fg.trigger('change')
            fg.trigger('blur')
        }
    }).fail(function (e) {
        if (e && e.responseText) {
            actionFail(e.responseText);
        } else {
            actionFail();
        }
    })
}

function editMessageLabels(entityType, entityId) {
    $.ajax({
        url: `/${appLocation}labels/editModal`,
        context: document.body, type: 'get',
        data: {entityType, entityId}
    }).done(function (message) {
        const box = bootbox.dialog({
            title: "Labels Bearbeiten",
            message,
            buttons: {
                confirm: {
                    label: "Bestätigen",
                    className: "btn-success",
                    callback: function () {
                        $.ajax({
                            url: `/${appLocation}labels/set`,
                            context: document.body, type: 'post',
                            data: $("#messageLabelsForm").serialize()
                        }).done(function () {
                            actionSuccess();
                            $(`#messageLabels${entityType}-${entityId}`).load(`/${appLocation}labels/get?entityId=${entityId}&entityType=${entityType}`);
                        }).fail(function (error) {
                            actionFail(error)
                        })
                    }
                },
                close: {
                    label: "Abbrechen",
                    className: "btn-danger",
                }
            },
        });
    }).fail(function (e) {
        actionFail(e);
    })
}

